import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'folder/:id',
    loadChildren: () => import('./folder/folder.module').then( m => m.FolderPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'rgpd',
    loadChildren: () => import('./rgpd/rgpd.module').then( m => m.RgpdPageModule)
  },  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'patrimoine',
    loadChildren: () => import('./patrimoine/patrimoine.module').then( m => m.PatrimoinePageModule)
  },
  {
    path: 'patrimoine-edit-marker',
    loadChildren: () => import('./patrimoine-edit-marker/patrimoine-edit-marker.module').then( m => m.PatrimoineEditMarkerPageModule)
  }


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
